import { render, staticRenderFns } from "./BetonObjekatIndex.vue?vue&type=template&id=a9818716&scoped=true&"
import script from "./BetonObjekatIndex.vue?vue&type=script&lang=js&"
export * from "./BetonObjekatIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9818716",
  null
  
)

export default component.exports